<template>
  <div
    :class="[$style.line, { [$style.lineHead]: isHead }]"
    :style="{ paddingLeft: `${depth * 20}px` }"
  >
    <span :class="$style.key">
      {{ name }}
    </span>

    <button
      v-if="isValueButton"
      :class="[$style.value, $style.valueObjectKeys]"
      type="button"
      @click="$emit('arrowClick', $event)"
    >
      {{ value }}
    </button>
    <span v-else :class="$style.value">
      <LimitedString :class="$style.valueText" :value="value" />
    </span>

    <button
      v-if="opened !== null"
      :class="[
        $style.arrow,
        {
          [$style.arrowOpened]: opened,
        },
      ]"
      type="button"
      @click="$emit('arrowClick', $event)"
    >
      <SvgIcon width="18" height="18" src="icon-sprite.svg#expand-arrow" />
    </button>
  </div>
</template>

<script>
import LimitedString from './LimitedString.vue';
import SvgIcon from './SvgIcon.vue';

export default {
  components: { LimitedString, SvgIcon },
  props: {
    depth: { type: Number, default: 1 },
    name: { type: String, required: true },
    value: { type: [String, Number], default: '' },
    opened: { type: Boolean, default: null },
    isValueButton: { type: Boolean, default: false },
    isHead: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" module>
.line {
  display: flex;
}
.key,
.arrow {
  flex: none;

  &.arrowOpened {
    transform: rotate(180deg);
  }
}
.value {
  flex: 1 1 auto;

  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  text-align: start;

  color: #2f3543;

  padding: 10px 30px;
  padding-right: 20px;
  line-break: anywhere;
}

.key {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;

  letter-spacing: 0.02em;
  text-align: start;

  color: #3f4757;

  width: 155px;
  padding: 10px 0;
}

.valueObjectKeys {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;

  letter-spacing: 0.02em;

  color: #3f4757;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.line:nth-child(odd) {
  background: var(--secondary-cell-color);
  border: 1px solid var(--table-border-color);
}

.line:nth-child(even) {
  border-left: 1px solid var(--table-border-color);
  border-right: 1px solid var(--table-border-color);
}

.arrow {
  padding: 0 10px;
  display: block;
  &.arrowOpened {
    transform: rotate(180deg);
  }


  @media print {
    opacity: 0;
  }
}

.line {
  &:last-child {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    border-bottom: 1px solid var(--table-border-color);
  }
  &:first-child {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
}

.line.lineHead {
  background: var(--table-head-color);
  border-color: transparent;
  
  @media print{
    border: 1px solid var(--table-border-color)
  }
  & + .line {
    &:first-child {
      border-top: none;
    }
  }
}
</style>
